import React from "react";
import { Box, Typography } from "@mui/material";

interface IProps {
  title: string;
  children?: React.ReactNode;
}
const MainInfoValue = ({ title, children }: IProps): React.ReactElement => (
  <Box display="flex" alignItems="center" whiteSpace="break-spaces">
    <Typography sx={{ fontWeight: "bold", fontSize: "16px" }} variant="subtitle2">
      {title}:&nbsp;
    </Typography>
    {children}
  </Box>
);

export default MainInfoValue;
